exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Top-module__wrapper___RiPDJ{display:grid;gap:1em;justify-items:end}@media screen and (min-width:850px){.Top-module__wrapper___RiPDJ{grid-template-columns:1fr auto}}.Top-module__wrapper___RiPDJ .Top-module__buttons___1kwd5{display:grid;gap:8px;grid-auto-flow:column}.Top-module__wrapper___RiPDJ label{margin-bottom:0}.Top-module__wrapper___RiPDJ label button{width:100%;height:100%}.Top-module__wrapper___RiPDJ .Top-module__file-input___3t-4t{display:none}", ""]);

// exports
exports.locals = {
	"wrapper": "Top-module__wrapper___RiPDJ",
	"buttons": "Top-module__buttons___1kwd5",
	"file-input": "Top-module__file-input___3t-4t"
};